import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import PropTypes from 'prop-types';
import css from './SizeGuideOverlay.module.scss';
import Overlay from '../Ovly';
import SIZE_GUIDES from './data';
import SizeGuideTable from '../SizeGuideTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
var moduleClass = 'size-guide';

var SizeGuideOverlay = function SizeGuideOverlay(_ref) {
  var title = _ref.title,
      type = _ref.type;
  var sizeGuides = SIZE_GUIDES[type.toUpperCase()] || [];
  var barTitle = sizeGuides.barTitle,
      footer = sizeGuides.footer;
  var compact = type === 'BRA_FULL';
  var actualTitle = title || barTitle || 'Size Guide';
  var id = 'size-guide-title';
  return /*#__PURE__*/_jsxs(Overlay, {
    ariaLabelledBy: id,
    button: /*#__PURE__*/_jsx("div", {
      className: css.sizeGuideButton,
      children: "Size Guide"
    }),
    label: actualTitle,
    noPadding: true,
    wide: true,
    children: [/*#__PURE__*/_jsx("header", {
      className: "ada-hidden",
      id: id,
      children: actualTitle
    }), /*#__PURE__*/_jsxs("div", {
      className: css.body,
      children: [sizeGuides.guides.length > 0 && sizeGuides.guides.map(function (sizeGuide) {
        return /*#__PURE__*/_createElement(SizeGuideTable, _objectSpread(_objectSpread({}, sizeGuide), {}, {
          compact: compact,
          includeGender: false,
          moduleClass: moduleClass,
          key: "guide-".concat(sizeGuide.title)
        }));
      }), footer && /*#__PURE__*/_jsxs("footer", {
        className: css.footer,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.footerTitle,
          children: footer.title
        }), /*#__PURE__*/_jsx("div", {
          className: css.footerCopy,
          dangerouslySetInnerHTML: {
            __html: footer.copy
          }
        })]
      })]
    })]
  });
};

SizeGuideOverlay.displayName = 'SizeGuideOverlay';
SizeGuideOverlay.defaultProps = {
  compact: false,
  footer: false,
  title: 'Size Guide'
};
SizeGuideOverlay.propTypes = {
  compact: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string.isRequired
};
export default /*#__PURE__*/memo(SizeGuideOverlay);